export function timestampToTime(timestamp) {
  var date = timestamp;// new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  return Y + M + D + h + m + s;
}

export function timestampToDate(date) {
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  return Y + M + D;
}

export function formatTime (timestamp, format='Y-M-D h:m') {
  var formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
  var returnArr = []
  var date = new Date(timestamp)

  returnArr.push(date.getFullYear())
  returnArr.push(formatNumber(date.getMonth() + 1))
  returnArr.push(formatNumber(date.getDate()))

  returnArr.push(formatNumber(date.getHours()))
  returnArr.push(formatNumber(date.getMinutes()))
  returnArr.push(formatNumber(date.getSeconds()))

  for (var i in returnArr) {
      format = format.replace(formateArr[i], returnArr[i])
  }
  return format
}

// 转化日期 如2018-7-6 -->(2018-07-06)
function formatNumber(n) {
  n = n.toString()
  return n[1] ? n : "0" + n
}
// 处理开始时间最开始时间和结束时间最后时间
export function getDayRangeBySetHours(start, end) {
  const date = new Date(start);
  const dateEnd = new Date(end);
  return {
    start: new Date(date).setHours(0, 0, 0, 0),
    end: new Date(dateEnd).setHours(23, 59, 59, 999)
  };
}
